import Backbone from 'backbone'
import _ from 'underscore'
import HeaderUserViewTemplate from '../templates/header-user.tpl'
import config from '../config'
import user from '../user'

const HeaderUserView = Backbone.View.extend({
    tagName: 'div',
    events: {
        'click .login': 'login',
        'click .profile': 'profile',
    },
    initialize() {
        this.template = _.template(HeaderUserViewTemplate)
        this.listenTo(user, 'change', this.render)
    },
    render() {
        this.$el.html(this.template({
            handheld: config.get('handheld'),
            uid: user.get('uid'),
            username: user.get('username'),
            loading: user.get('loading'),
        }))
        return this
    },
    login() {
        Backbone.history.navigate('login', { trigger: true })
    },
    profile() {
        Backbone.history.navigate('profile', { trigger: true })
    },
})

export default HeaderUserView
